import { useMutation } from '@tanstack/react-query';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { deleteMIPLoanDefinitionData } from '@dealstack/frontend/shared/dataExchange/services/mip.service';

export const useDeleteLoan = ({ onSuccess }: { onSuccess?: () => void }) => {
	const tMipManage = useTranslationMipManage();

	return useMutation({
		mutationFn: (data: { loanDefinitionId: string }) => deleteMIPLoanDefinitionData(data),
		onSuccess: () => {
			showToastV2({
				state: 'success',
				message: tMipManage('root.loans.toast.removed_successfully'),
			});
			onSuccess?.();
		},
		onError: () => {
			showToastV2({
				state: 'error',
				message: tMipManage('root.loans.toast.remove_failed'),
			});
		},
	});
};
